export default {
  black: '#000000',
  white: '#ffffff',

  /* ADD PROJECT COLORS HERE */
  'blue-100': '#f4fbfe',
  'blue-300': '#caefff',
  'blue-400': '#5fb8ee',
  'blue-600': '#008ce1',
  'blue-800': '#0067a5',

  'bluegrey-100': '#e9eced',
  'bluegrey-200': '#d6dbea',
  'bluegrey-500': '#8b96b8',
  'bluegrey-700': '#393c5c',
  'bluegrey-800': '#003653',
  'bluegrey-900': '#04192e',

  'green-200': '#c9f6d5',
  'green-400': '#82e19a',
  'green-500': '#53cb72',
  'green-900': '#31a14e',

  'orange-025': '#fffbf4',
  'orange-200': '#ffe4b1',
  'orange-400': '#ffcb63',
  'orange-500': '#ffbe3b',
  'orange-900': '#e69a00',

  'purple-200': '#decaff',
  'purple-400': '#b98fff',
  'purple-500': '#a269ff',

  'red-300': '#fbbbb9',
  'red-400': '#f9736c',
  'red-500': '#f2382f',

  'teal-500': '#42d0b6',

  'grey-dark': '#393c5c',
  'grey-mid': 'bluegrey-500',
  'grey-midlight': '#d9e2e6',
  'grey-light': 'bluegrey-200',
  'grey-extralight': '#dff0f6',
  'grey-ultralight': '#f4fbfe',
  'blue-dark': '#006384',
  'blue-middark': '#0299cc',
  'blue-mid': '#008CE1',
  'blue-light': 'blue-400',
  'blue-lighter': '#F4FBFE',
  'bluewhite-mid': '#f4fbfe',
  'bluegrey-mid': '#e2f2f9',
  'bluegrey-dark': '#003653',
  'red-mid': '#f2382f',
  'red-light': '#F9736C',
  'red-lighter': '#FBBBB9',
  'red-dark': '#DF493B',
  'purple-mid': '#A269FF',
  'purple-light': '#B98FFF',
  'purple-lighter': '#DECAFF',
  'orange-mid': '#FFBA2F',
  'orange-light': '#FFCB63',
  'orange-lighter': '#FFE4B1',
  'green-mid': '#53cb72',
  'green-light': '#82e19a',
  'green-lighter': '#c9f6d5',
  'pink-mid': '#ff6cba',

  /* GRAPH COLORS */
  'graph-green': '#53CB72',
  'graph-green-light': '#D6F6DE',
  'graph-blue': '#24ACFF',
  'graph-pink': '#FF97C2',
  'graph-orange': '#FFBA2F',
  'graph-orange-light': '#FFEBC2',
  'graph-red': '#ff6866',
  'graph-red-light': '#fcd7d5',
  'graph-lilac': '#c18dff',
  'graph-grey-mid': '#d5dbeb',
  'graph-grey-shade': '#8b96b8',

  /* APPLIANCE COLORS */
  'appliance-dishwasher': '#2491d4',
  'appliance-kettle': '#9b5eff',
  'appliance-microwave': '#de59b0',
  'appliance-oven': '#f1524b',
  'appliance-tumbledryer': '#ff9d2f',
  'appliance-washingmachine': '#ffc500',
  'appliance-toaster': '#9bda2f',
  'appliance-heatpump': '#42cd66',
  'appliance-fridge': '#42d0b6',
  'appliance-alwayson': '#8b96b8',
  'appliance-others': '#d5dbeb',

  /* MESSAGE BOX COLORS */
  'message-box-warning': 'orange-mid',
  'message-box-error': 'red-mid',
  'message-box-reminder': 'blue-mid',

  /* STATES */
  default: '#3D9AE3',
  warning: '#FFB61A',
  error: '#FF583B',

  knownColor(value) {
    if (this[value]) {
      if (!this[value].startsWith('#')) {
        return this.knownColor(this[value])
      }
      return this[value]
    }
    return value
  },
  convertHex(hex, opacity) {
    const hexValue = hex.replace('#', '')
    const r = parseInt(hexValue.substring(0, 2), 16)
    const g = parseInt(hexValue.substring(2, 4), 16)
    const b = parseInt(hexValue.substring(4, 6), 16)

    return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')'
  },
  knownColorWithOpacity(value, opacity) {
    if (value && value.startsWith('rgba')) {
      return value
    }
    if (this[value]) {
      if (!this[value].startsWith('#')) {
        const hexValue = this.knownColor(this[value])
        return this.convertHex(hexValue, opacity)
      }
      const hexValue = this.colorcolor(this[value], 'hex')
      return this.convertHex(hexValue, opacity)
    }
    const hexRawValue = this.colorcolor(value, 'hex')
    return this.convertHex(hexRawValue, opacity)
  },
  colorcolor(color, newColor, calculateOpacity) {
    if (!newColor) {
      newColor = 'rgba'
    }
    if (!calculateOpacity) {
      calculateOpacity = false
    }
    color = color.toLowerCase()
    newColor = newColor.toLowerCase()
    let returnedColor = color
    let r, g, b, a
    const roundTo = 4
    const colorDefinitions = {
      hex: {
        re: /^#([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        example: ['00ff00', '336699'],
        toRGBA(bits) {
          return [
            parseInt(bits[1], 16),
            parseInt(bits[2], 16),
            parseInt(bits[3], 16),
            1
          ]
        }
      }
    }

    // Search the color definitions for a match
    for (const colorDefinition in colorDefinitions) {
      const re = colorDefinitions[colorDefinition].re
      const processor = colorDefinitions[colorDefinition].toRGBA
      const bits = re.exec(color)
      if (bits) {
        const channels = processor(bits)
        r = channels[0]
        g = channels[1]
        b = channels[2]
        a = +(Math.round(channels[3] + ('e+' + roundTo)) + ('e-' + roundTo))
      }
    }
    r = Math.round(r < 0 || isNaN(r) ? 0 : r > 255 ? 255 : r)
    g = Math.round(g < 0 || isNaN(g) ? 0 : g > 255 ? 255 : g)
    b = Math.round(b < 0 || isNaN(b) ? 0 : b > 255 ? 255 : b)
    a = a < 0 || isNaN(a) ? 0 : a > 1 ? 1 : a

    switch (newColor) {
      case 'hex':
        returnedColor =
          '#' +
          ('0' + r.toString(16)).slice(-2) +
          ('0' + g.toString(16)).slice(-2) +
          ('0' + b.toString(16)).slice(-2)
        break
      default:
        if (calculateOpacity) {
          ;[r, g, b, a] = this.calculateOpacityFromWhite(r, g, b, a)
        }
        returnedColor = `rgba(${r},${g},${b},${a})`
        break
    }

    return returnedColor
  },
  calculateOpacityFromWhite(r, g, b, a) {
    let min = 0
    a = (255 - (min = Math.min(r, g, b))) / 255
    r = (0 || (r - min) / a).toFixed(0)
    g = (0 || (g - min) / a).toFixed(0)
    b = (0 || (b - min) / a).toFixed(0)
    a = parseFloat(a.toFixed(4))

    return [r, g, b, a]
  },
  toPercent(amount, limit) {
    return amount / limit
  }
}
